module.exports = require('./helpers/bundle-url').getBundleURL('1hhWI') + "logo.c51670a8.svg";